import { skillsData } from "../../utils/data/skillsData";
import { skillsImage } from "../../utils/skillsImage";
import Marquee from "react-fast-marquee";

function SkillsSlider() {
  return (
    <div id="skills" className="relative z-50 ">
      {/* skill slider showing different skills in blocks */}
      <div className="w-full my-6">
        <Marquee
          gradient={false}
          speed={80}
          pauseOnHover={true}
          pauseOnClick={true}
          delay={0}
          play={true}
          direction="left"
        >
          {skillsData.map((skill, id) => (
            <div
              className="w-36 min-w-fit h-fit flex flex-col items-center justify-center transition-all duration-500 m-3 sm:m-5 rounded-lg group relative hover:scale-[1.15] cursor-pointer"
              key={id}
            >
              <div className="h-full w-full rounded-lg border border-[#222222] bg-[#222222] shadow-none  transition-all duration-500">
                <div className="flex flex-col items-center justify-center gap-3 p-6">
                  <div className="h-8 sm:h-10">
                    <img
                      src={skillsImage(skill)}
                      alt={skill}
                      width={40}
                      height={40}
                      className="h-full w-auto rounded-lg"
                    />
                  </div>
                  <p className="text-white text-base font-['Helvetica']">{skill}</p>
                </div>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}

export default SkillsSlider;
